import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import { setResume } from "../../../../../redux/actions/profileActions";
import icons from "../../../assets/icons/icon-collection.svg";
import { PageLoader } from "../../../components/PageLoader";
import Layout from "../../../layout";
import { getAllEducationAction } from "../../../redux/actions/educationActions";
import { getAllExperienceAction } from "../../../redux/actions/experienceAction";
import { getProfileAction } from "../../../redux/actions/profileActions";
import { getMySkillsAction } from "../../../redux/actions/skillsAction";
import { ternaryResolver } from "../../../utils/helpers";
import BackButton from "../../../components/BackButton";
import "./index.scss";
import "./style.css";
import ProfileLayout from "./Layout";

const Profile = () => {
  const [pageLoading, setPageLoading] = useState(false);
  const dispatch = useDispatch();
  const { profile, education, skill } = useSelector((store) => store);
  const [experiences, setExperiences] = useState([]);
  const { profileData } = profile;
  const { myEducations } = education;
  const { mySkills } = skill;

  useEffect(() => {
    setPageLoading(true);
    Promise.all([
      getProfileAction(dispatch),
      getAllEducationAction(dispatch),
      getMySkillsAction(dispatch),
    ]).finally(() => setPageLoading(false));
  }, [dispatch]);
  useEffect(() => {
    handleGetExperience();
  }, []);
  const handleGetExperience = async () => {
    try {
      const response = await getAllExperienceAction(dispatch);
      if (response && response.payload) {
        setExperiences(response.payload);
      } else {
        setExperiences([]);
      }
    } catch (error) {
      console.error(error);
      setExperiences([]);
    }
  };
  const stripHtmlTags = (str) => {
    return str.replace(/<[^>]*>/g, "");
  };

  return (
    <Layout>
      <BackButton />
      {pageLoading ? (
        <PageLoader />
      ) : (
        <ProfileLayout>
          {/* About Section */}
          <div
            style={{
              marginTop: "20px",
              padding: "2rem",
              backgroundColor: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              marginBottom: "2rem",
            }}
          >
            <div
              style={{
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "1rem",
                marginBottom: "1rem",
              }}
            >
              <p
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  color: "#333",
                  margin: 0,
                }}
              >
                About
              </p>
            </div>
            <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.5" }}>
              {profileData.about || "Nothing to display"}
            </p>
          </div>

          {/* Education/Certifications Section */}
          <div
            style={{
              padding: "2rem",
              backgroundColor: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              marginBottom: "2rem",
            }}
          >
            <div
              style={{
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "1rem",
                marginBottom: "1rem",
              }}
            >
              <p
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  color: "#333",
                  margin: 0,
                }}
              >
                EDUCATION/CERTIFICATIONS
              </p>
            </div>
            {myEducations.length ? (
              myEducations.map((data, index) => (
                <Link
                  key={data.id}
                  to={`/profile/edit/education/${data.id}`}
                  style={{
                    textDecoration: "none",
                    color: "#555",
                    display: "block",
                    marginBottom: "1rem",
                  }}
                >
                  <p
                    style={{
                      fontSize: "1.1rem",
                      margin: 0,
                      fontWeight: "500",
                    }}
                  >
                    {data.school}
                  </p>
                  <p style={{ margin: "0.25rem 0 0", fontSize: "0.9rem" }}>
                    {`${data.degree} ${data.field_of_study} (${ternaryResolver(
                      `${data.end_date}`.toLowerCase() === "present",
                      data.end_date,
                      new Date(data?.end_date).getFullYear()
                    )})`}
                  </p>
                </Link>
              ))
            ) : (
              <div style={{ marginTop: "1rem" }}>
                <p style={{ color: "#555", fontSize: "1rem" }}>
                  Nothing to display
                </p>
              </div>
            )}
          </div>

          {/* Skills/Interests Section */}
          <div
            style={{
              padding: "2rem",
              backgroundColor: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              marginBottom: "2rem",
            }}
          >
            <div
              style={{
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "1rem",
                marginBottom: "1rem",
              }}
            >
              <p
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  color: "#333",
                  margin: 0,
                }}
              >
                SKILLS/INTERESTS
              </p>
            </div>
            <ul
              style={{
                display: "flex",
                flexWrap: "wrap",
                margin: 0,
                padding: 0,
                listStyle: "none",
              }}
            >
              {mySkills?.skills?.length ? (
                mySkills.skills.map((skill) => (
                  <li
                    key={skill}
                    style={{
                      margin: "0.5rem",
                      padding: "0.5rem 1rem",
                      border: "1px solid #ddd",
                      borderRadius: "20px",
                      fontSize: "0.9rem",
                      color: "#555",
                    }}
                  >
                    {skill}
                  </li>
                ))
              ) : (
                <li
                  style={{
                    margin: "0.5rem",
                    padding: "0.5rem 1rem",
                    fontSize: "0.9rem",
                    color: "#555",
                  }}
                >
                  No skill added
                </li>
              )}
            </ul>
          </div>

          {/* Resume/Documents & Links Section */}
          <div
            style={{
              padding: "2rem",
              backgroundColor: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              marginBottom: "2rem",
            }}
          >
            <div
              style={{
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "1rem",
                marginBottom: "1rem",
              }}
            >
              <p
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  color: "#333",
                  margin: 0,
                }}
              >
                RESUME/DOCUMENTS
              </p>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              {profileData?.resume && (
                <a
                  href={profileData.resume}
                  download
                  style={{
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                    color: "#0d6efd",
                    marginBottom: "1rem",
                  }}
                >
                  <svg width="20" height="24" style={{ marginRight: "0.5rem" }}>
                    <use href={`${icons}#file`}></use>
                  </svg>
                  {profileData.resumeName ?? "Rèsumé"}
                  <span
                    style={{
                      backgroundColor: "#0d6efd",
                      color: "#fff",
                      padding: "0.2rem 0.5rem",
                      borderRadius: "4px",
                      marginLeft: "1rem",
                      fontSize: "0.8rem",
                    }}
                  >
                    Default
                  </span>
                </a>
              )}
              {profileData?.links && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "1rem",
                  }}
                >
                  <svg width="22" height="22" style={{ marginRight: "0.5rem" }}>
                    <use href={`${icons}#link`}></use>
                  </svg>
                  {profileData?.links[0]?.facebook && (
                    <a
                      href={profileData.links[0].facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: "underline",
                        color: "#0d6efd",
                        marginRight: "1rem",
                      }}
                    >
                      Facebook
                    </a>
                  )}
                  {profileData?.links[0]?.linkdn && (
                    <a
                      href={profileData.links[0].linkdn}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: "underline",
                        color: "#0d6efd",
                        marginRight: "1rem",
                      }}
                    >
                      LinkedIn
                    </a>
                  )}
                  {profileData?.links[0]?.twitter && (
                    <a
                      href={profileData.links[0].twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: "underline",
                        color: "#0d6efd",
                        marginRight: "1rem",
                      }}
                    >
                      Twitter
                    </a>
                  )}
                  {profileData?.links[0]?.potfolio && (
                    <a
                      href={profileData.links[0].potfolio}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: "underline",
                        color: "#0d6efd",
                      }}
                    >
                      Portfolio
                    </a>
                  )}
                  {!profileData?.resume &&
                    !profileData?.links[0]?.facebook &&
                    !profileData?.links[0]?.linkdn &&
                    !profileData?.links[0]?.twitter &&
                    !profileData?.links[0]?.potfolio && (
                      <p style={{ padding: "0.5rem 1rem", color: "#555" }}>
                        Nothing to display
                      </p>
                    )}
                </div>
              )}
            </div>

            {/* Experiences Section */}
            <div style={{ paddingTop: "2rem" }}>
              <div
                style={{
                  borderBottom: "1px solid #e0e0e0",
                  paddingBottom: "1rem",
                  marginBottom: "1rem",
                }}
              >
                <p
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#333",
                    margin: 0,
                  }}
                >
                  EXPERIENCES
                </p>
              </div>
              {Array.isArray(experiences) && experiences.length ? (
                experiences.map((data, index) => (
                  <div key={data.id} style={{ marginBottom: "1.5rem" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "0.5rem",
                      }}
                    >
                      <div style={{ flex: "1", marginRight: "1rem" }}>
                        <p style={{ color: "#3A6ED4", margin: "0 0 0.25rem" }}>
                          COMPANY NAME
                        </p>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "1rem",
                            fontWeight: "500",
                            color: "#555",
                          }}
                        >
                          {data.campany_name}
                        </p>
                      </div>
                      <div style={{ flex: "1", marginRight: "1rem" }}>
                        <p style={{ color: "#3A6ED4", margin: "0 0 0.25rem" }}>
                          JOB POSITION
                        </p>
                        <p
                          style={{ margin: 0, fontSize: "1rem", color: "#555" }}
                        >
                          {data.title}
                        </p>
                      </div>
                      <div style={{ flex: "1", marginRight: "1rem" }}>
                        <p style={{ color: "#3A6ED4", margin: "0 0 0.25rem" }}>
                          START DATE
                        </p>
                        <p
                          style={{ margin: 0, fontSize: "1rem", color: "#555" }}
                        >
                          {data.start_date}
                        </p>
                      </div>
                      <div style={{ flex: "1" }}>
                        <p style={{ color: "#3A6ED4", margin: "0 0 0.25rem" }}>
                          END DATE
                        </p>
                        <p
                          style={{ margin: 0, fontSize: "1rem", color: "#555" }}
                        >
                          {data.end_date}
                        </p>
                      </div>
                    </div>
                    <div>
                      <p style={{ color: "#3A6ED4", margin: "0 0 0.25rem" }}>
                        ACHIEVEMENTS
                      </p>
                      <p
                        style={{ margin: 0, fontSize: "0.9rem", color: "#555" }}
                      >
                        {stripHtmlTags(data.achievements)}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ marginTop: "1rem" }}>
                  <p style={{ color: "#555", fontSize: "1rem" }}>
                    Nothing to display
                  </p>
                </div>
              )}
            </div>
          </div>
        </ProfileLayout>
      )}
    </Layout>
  );
};

export default Profile;
